<template>
  <SamModal
    :is-open="Boolean(component)"
    v-bind="modalProps"
    @close="handleClose"
  >
    <component
      :is="component"
      v-if="Boolean(component)"
      v-bind="props"
      @close="handleClose"
    />
  </SamModal>
</template>
<script>
import SamModal from '../SamModal/SamModal.vue';
import SAMORA_EVENTS from '../../../utils/events';
import EventBus from '../../../utils/eventBus';

export default {
  name: 'SamModalManager',
  components: {
    SamModal,
  },
  data() {
    return {
      component: null,
      modalProps: null,
      props: null,
    };
  },
  created() {
    EventBus.on(SAMORA_EVENTS.OPEN_MODAL, this.handleOpen);
    EventBus.on(SAMORA_EVENTS.CLOSE_MODAL, this.handleClose);
  },
  methods: {
    handleOpen({ component, modalProps = null, props = null }) {
      this.component = component;
      this.modalProps = modalProps;
      EventBus.emit(SAMORA_EVENTS.MODAL_OPENED, {
        component,
        modalProps,
        props,
      });
      this.props = props;
    },
    handleClose() {
      EventBus.emit(SAMORA_EVENTS.MODAL_CLOSED, {
        component: this.component,
        modalProps: this.modalProps,
        props: this.props,
      });
      this.component = null;
      this.modalProps = null;
      this.props = null;
    },
  },
};
</script>
